import * as React from 'react';
import { useLocation } from 'react-router-dom';
import intl from 'react-intl-universal';
import { get } from 'lodash';
import moment from 'moment';

import { ReactComponent as SubmittedBg } from '@svg/mobile_questionnaire_submitted.svg';

import './index.less';

const { useMemo } = React;
const Submitted: React.FC = () => {
    const { state } = useLocation<{ last_submit_time: number }>();

    const time = useMemo(() => {
        return moment(get(state, 'last_submit_time') || undefined).format('YYYY/MM/DD');
    }, [state]);


    return (
        <div className="mobile-submitted-wrapper">
            <SubmittedBg />
            <p className="submitted-title">{intl.get('submitted')}</p>
            <p className="submitted-time-text">{intl.get('submittedTime', { time })}</p>
        </div>
    );
};

export default Submitted;
